
import { foods1 } from './foods1';
import { foods2 } from './foods2';
import { foods3 } from './foods3';
import { foods4 } from './foods4';
import { foods5 } from './foods5';
import { foods6 } from './foods6';
import { foods7 } from './foods7';
import { foods8 } from './foods8';
import { foods9 } from './foods9';
import { foods10 } from './foods10';
import { foods11 } from './foods11';
import { foods12 } from './foods12';
import { FoodItem, SymptomItem, FoodCategory, SymptomCategory, Language } from './db-types';
import { symptoms as symptomsList } from './symptoms-complete-list';

// ============================================================================
// COMPREHENSIVE BILINGUAL FOOD DATABASE (EN/FR)
// ============================================================================

// Re-export shared types for consumption by other files
export type { FoodItem, SymptomItem, FoodCategory, SymptomCategory, Language };

// Export Symptoms List
export const symptoms = symptomsList;

// Export Consolidated Food List
// Merging items from 12 split files to reach >2300 items
export const foods: FoodItem[] = [
  ...foods1,
  ...foods2,
  ...foods3,
  ...foods4,
  ...foods5,
  ...foods6,
  ...foods7,
  ...foods8,
  ...foods9,
  ...foods10,
  ...foods11,
  ...foods12
];

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

// Helper to check if item is in the base library
export const isBaseIngredient = (name: string, lang: Language): boolean => {
    const lowerName = name.toLowerCase().trim();
    
    // 1. Direct check against the aggregated list
    const found = foods.some(f => f[lang].toLowerCase() === lowerName);
    if (found) return true;
    
    // 2. Check keywords (optional, can be strict if needed)
    return foods.some(f => f.keywords && f.keywords.some(k => k.toLowerCase() === lowerName));
};
